import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Breadcrumb from "../../../../components/Breadcrum";
import "./AgriculturalCommodities.css";

export default function AgriculturalCommodities() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const agriculturalProducts = [
    {
      id: 1,
      name: "Fruits",
      image: "./assets/img/agriculturalCommodities/Fruits.png",
      path: "/business/agricultural-commodities/FruitsAndVeg",
    },
    {
      id: 5,
      name: "Vegetables",
      image: "./assets/img/agriculturalCommodities/vegetables.png",
      path: "/business/agricultural-commodities/Vegetables",
    },
    {
      id: 2,
      name: "Spices",
      image: "./assets/img/agriculturalCommodities/Spices.jpg",
      path: "/business/agricultural-commodities/spices",
    },
    {
      id: 3,
      name: "Rices",
      image: "./assets/img/agriculturalCommodities/Rices.jpg",
      path: "/business/agricultural-commodities/rice",
    },
    {
      id: 4,
      name: "Dry Fruits & Nuts",
      image: "./assets/img/agriculturalCommodities/Dry-Fruits-Nuts.jpg",
      path: "/business/agricultural-commodities/nuts",
    },
  ];

  return (
    <>
      <Breadcrumb
        title="Agricultural Commodities"
        backgroundImage="./assets/img/contact-banner.png"
        height="40vh"
      />

      <section className="pp-section">
        <div className="container">
          <h1 className="pp-title">Agricultural Commodities</h1>

          <p className="pp-subtitle">From farm fresh produce to essential grains and spices, we provide high quality Agricultural Products to customers worldwide.</p>

          <div className="pp-grid">
            {agriculturalProducts.map((product) => (
              <div className="pp-card" key={product.id}>
                <div className="pp-img-box">
                  <img
                    src={product.image}
                    alt={product.name}
                    onError={(e) =>
                    (e.target.src =
                      "https://via.placeholder.com/400x300?text=Image")
                    }
                  />
                </div>

                <div className="pp-info">
                  <h2 className="pp-name">{product.name}</h2>

                  <button
                    className="view-btn"
                    onClick={() => navigate(product.path)}
                  >
                    View Details <ArrowRight size={16} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}